import {
  ChakraBox,
  ChakraText,
  EquipUIFireflyV2Theme,
  EquipUITheme,
} from '@equip.health/ui';

import { WEEK_VIEW_ITEM_HEIGHT } from '~/lib/constants/calendar.constants';

const TOP_LEVEL_ID = 'week-time-item';
const {
  neutral: { line: neutralLine },
} = EquipUIFireflyV2Theme.colors;
const { label } = EquipUITheme.typography;

const textProps: Record<string, string> = {
  borderLeft: `1px solid ${neutralLine}`,
  borderRight: `1px solid ${neutralLine}`,
  height: `${WEEK_VIEW_ITEM_HEIGHT}px`,
  textAlign: 'center',
};

interface ScheduleWeekTimeItemProps {
  time: string;
}

const ScheduleWeekTimeItem = ({ time }: ScheduleWeekTimeItemProps) => {
  return (
    <ChakraBox id={`${TOP_LEVEL_ID}__${time}`}>
      <ChakraText
        id={`${TOP_LEVEL_ID}__${time}-text`}
        {...label}
        {...textProps}
      >
        {time}
      </ChakraText>
      <ChakraText
        borderBottom={`1px solid ${neutralLine}`}
        id={`${TOP_LEVEL_ID}__${time}-blank`}
        {...textProps}
      />
    </ChakraBox>
  );
};

export default ScheduleWeekTimeItem;
